import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { PagingParam } from 'app/services/common-request.service';
import { CommonTableService, TableColumn } from 'app/services/common-table.service';
import { FieldMappingService, LayerCategoryStandardSchema } from 'app/services/field-mapping.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { AppLayer } from 'app/services/layer.service';
import { Subscription } from 'rxjs';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { CommonTablePagingComponent } from '../common-datagrid/common-table-paging/common-table-paging.component';
import { A3iService } from 'app/services/a3i.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ContextMenuService } from 'ngx-contextmenu';
import { CommonTemplatesService } from 'app/services/common-templates.service';

interface ParseCodeItem {
	value: 's' | 'e' | 'all';
	label: string;
}
type TableType = 'source' | 'result';

@Component({
  selector: 'app-feat-a3i',
  templateUrl: './feat-a3i.component.html',
  styleUrls: ['./feat-a3i.component.css']
})
export class FeatA3iComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('tablePaging', { static: false }) tablePagingComp: CommonTablePagingComponent;
	@ViewChild('headerTempl', { static: false }) headerTempl: TemplateRef<any>;
	@ViewChild('checkboxHeaderTempl', { static: false }) checkboxHeaderTempl: TemplateRef<any>;
	@ViewChild('parseCodeCellTempl', { static: false }) parseCodeCellTempl: TemplateRef<any>;
	@ViewChild('checkCellTempl', { static: false }) checkCellTempl: TemplateRef<any>;
	@ViewChild('tableContextmenu', { static: false }) tableContextmenu;

	sourceColumns: TableColumn[];
	resultColumns: TableColumn[];
	sourceRows: any[] = [];
	resultRows: any[] = [];
	selectedSourceRows: any[] = [];
	selectedResultRows: any[] = [];

	pageSize = 1000;
	pageNumber = 1;
	totalNum: number;
	tableSorts = [];

	isCheckAll = false;
	isShowNena = false;
	parseCodes: ParseCodeItem[] = [
		{
			value: 'all',
			label: 'All'
		}, {
			value: 'e',
			label: 'Failure'
		}, {
			value: 's',
			label: 'Success'
		}
	];
	selectedParseCode: ParseCodeItem;

	readonly sourceTableId = 'sourceTable';
	readonly resultTableId = 'resultTable';

	private rowsAll: any[];
	private sourceColumns_nena: TableColumn[];
	private sourceColumns_legacy: TableColumn[];

	private selectedLayer: AppLayer;
	private lstStandardCols: LayerCategoryStandardSchema[];
	private stStandardCols: LayerCategoryStandardSchema[];

	private updateCol: string;
	resultCol: string;
	private idCol: string;
	private nguidCol: string;
	private inputAddrCol;
	parseCodeCol = 'parse_code';
	commentCol = 'comment';
	checkCol = 'check';
	private tableTypeCol = 'tableType';

	private selectedLayerSub: Subscription;
	private selectedRecordA3iSub: Subscription;
	private parseSub: Subscription;
	private saveParseSub: Subscription;
	private commitSub: Subscription;
	constructor(
		private toastr: ToastrService,
		private elemRef: ElementRef,
		private activityService: ActivityService,
		private attrFilterService: AttributeFilterService,
		private attrIndexService: AttrIndexService,
		private a3iService: A3iService,
		private commonService: CommonFunctionService,
		private commonTemplateService: CommonTemplatesService,
		private contextmenuService: ContextMenuService,
		private fieldMappingService: FieldMappingService,
		private gfoService: GfoService,
		private qcService: LayerQcService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private tableService: CommonTableService,
		private userService: UserService
	) { }

	onToggleCheck(idx: number, row) {
		if (row[this.tableTypeCol] === 'result') {
			this.sourceRows[idx][this.checkCol] = row[this.checkCol];
		} else {
			this.resultRows[idx][this.checkCol] = row[this.checkCol];
		}
		this.updateParseDisable();
		this.updateSaveParseDisable();
	}
	onToggleCheckAll() {
		this.sourceRows.forEach(r => r[this.checkCol] = this.isCheckAll);
		this.resultRows.forEach(r => r[this.checkCol] = this.isCheckAll);
		this.updateParseDisable();
		this.updateSaveParseDisable();
	}
	copyNguid(row) {
		const nguid = row[this.nguidCol];
		navigator['clipboard'].writeText(nguid);
	}

	filterRowsByParseCode() {
		const filtered = this.selectedParseCode.value === 'all' ? this.rowsAll : this.rowsAll.filter(r => r[this.parseCodeCol] === this.selectedParseCode.value);
		this.setRows(filtered);
	}
	setSourceColumnsByType() {
		this.sourceColumns = this.isShowNena ? this.sourceColumns_nena : this.sourceColumns_legacy;
		this.updateSourceColumnsDisplay();
	}

	onSelectRow(e, tableType: TableType) {
		const row = e.selected[0];
		const id = this.a3iService.getRecordId(row);
		if (tableType === 'result') {
			const sourceRow = this.sourceRows.find(r => this.a3iService.getRecordId(r) === id);
			if (sourceRow) {
				this.selectedSourceRows = [sourceRow];
			}
		} else if (tableType === 'source') {
			const resultRow = this.resultRows.find(r => this.a3iService.getRecordId(r) === id);
			if (resultRow) {
				this.selectedResultRows = [resultRow];
			}
		}
		this.a3iService.selectedRecordA3iBS.next({
			record: this.selectedSourceRows[0]
		})
	}
	onScroll(e, syncTableId) {
		if (!e.e.target) {
			return;
		}
		const scrollTop = e.e.target.scrollTop;
		const syncTableBodyElem = this.elemRef.nativeElement.querySelector(`#${syncTableId} datatable-body`);
		syncTableBodyElem.scrollTop = scrollTop;
	}
	onActivate(e: any) {
		if (e.type === 'mouseenter' && e.row) {
			const id = this.a3iService.getRecordId(e.row);
			this.sourceRows = this.sourceRows.map(r => {
				r.isHovering = this.a3iService.getRecordId(r) === id;
				return r;
			});
			this.resultRows = this.resultRows.map(r => {
				r.isHovering = this.a3iService.getRecordId(r) === id;
				return r;
			});
		}
	}
	onSort(e: any, tableId: string) {
		this.tableSorts = e.sorts;
		if (tableId === this.resultTableId) {
			this.sourceRows = this.sourceRows.map(r => r);
		} else if (tableId === this.sourceTableId) {
			this.resultRows = this.resultRows.map(r => r);
		}
	}
	onContextmenu(e: any) {
		if (e.type === 'body') {
			const event = e.event;
			const item = {
				row: e.content
			};
			this.contextmenuService.show.next({
				event: event,
				contextMenu: this.tableContextmenu,
				item: item
			});
			event.preventDefault();
			event.stopPropagation();
		}
	}
	async onPaging(pageNum: number) {
		this.pageNumber = pageNum;
		const isMapFilterOn = this.activityService.mapFilterBS.getValue().isOn;
		if (isMapFilterOn) {

		} else {
			await this.getData(pageNum);
		}
	}
	setRowClass(row: any) {
		if (row.isHovering) {
			return 'hovering-row';
		}
		return;
	}

	private clearTableData() {
		this.sourceRows = [];
		this.resultRows = [];
		this.selectedResultRows = [];
		this.selectedSourceRows = [];
	}
	private setTablePaging(totalNum: number) {
		this.totalNum = totalNum;
		this.tablePagingComp.reset(1, totalNum);
	}
	private setRows(data: any[]) {
		if (!data) {
			this.clearTableData();
			return;
		}
		this.sourceRows = data;
		this.sourceRows.forEach(i => {
			// table type
			i[this.tableTypeCol] = 'source';
		})
		this.resultRows = this.sourceRows.map((i, idx) => {
			const row = Object.assign({}, i);
			row[this.a3iService.uniqueIdCol] = this.a3iService.getRecordId(i);
			i[this.parseCodeCol] = null;
			const result = i[this.resultCol];
			if (result) {
				Object.keys(result).forEach(k => row[k] = result[k]);
				i[this.parseCodeCol] = result[this.parseCodeCol];
			}
			// table type
			row[this.tableTypeCol] = 'result';
			return row;
		});
		this.updateSourceColumnsDisplay();
		this.updateResultColumnsDisplay();

		this.updateParseDisable();
		this.updateSaveParseDisable();

		// Clear selected record
		this.clearSelectedRecord();
	}
	private clearSelectedRecord() {
		this.selectedSourceRows = [];
		this.selectedResultRows = [];
		this.a3iService.selectedRecordA3iBS.next({
			record: null
		});
	}
	private updateSourceColumnsDisplay() {
		// this.tableService.updateColumnsSmartDisplay(this.sourceRows, this.sourceColumns);
		setTimeout(() => {
			this.tableService.extendTableFull(this.elemRef, this.sourceTableId, this.sourceColumns, true);
			this.sourceColumns = this.sourceColumns.map(i => i);
		});
	}
	private updateResultColumnsDisplay() {
		// this.tableService.updateColumnsSmartDisplay(this.resultRows, this.resultColumns);
		// setTimeout(() => {
			this.resultColumns = this.tableService.extendTableFull(this.elemRef, this.resultTableId, this.resultColumns, true);					
			this.resultColumns = this.resultColumns.map(i => i);
		// });
	}
	private setCellClass = (e: { row; column: TableColumn; value; }) => {
		let cellClass = this.tableService.fixedCellClassToString(e.column.info.fixedCellClass);
		if (e.row[this.resultCol] && e.row[this.resultCol][this.parseCodeCol] === 's' && e.column.info.matchingResultCol) {
			const resultVal = e.row[this.resultCol][e.column.info.matchingResultCol];
			if (!resultVal && !e.value) {
				//
			} else if (resultVal !== e.value) {
				cellClass += 'qc-error-cell';
			}
		}
		return cellClass;
	}
	// Update parsed results: 1.to database, 2.display on table
	private async updateParseResult(data: any[]) {
		if (!data) {
			return;
		}
		const a3iOutputWithId: {output; ids: any[]}[] = [];
		data.forEach(i => {
			const ids = [];
			this.sourceRows.forEach((r, idx) => {
				if (i[this.inputAddrCol] === r[this.inputAddrCol] && !r[this.updateCol]) {
					ids.push(r[this.idCol]);
					r[this.resultCol] = i;
					r[this.parseCodeCol] = i[this.parseCodeCol];
					const resultRow = this.resultRows[idx];
					Object.keys(i).forEach(key => resultRow[key] = i[key]);
				}
			});
			a3iOutputWithId.push({
				output: i,
				ids: ids
			});
		})
		// Display parse result on table
			// this.tableService.updateColumnsSmartDisplay(this.resultRows, this.resultColumns);
		setTimeout(() => {
			this.updateResultColumnsDisplay();
			// this.resultColumns = this.tableService.extendTableFull(this.elemRef, this.resultTableId, this.resultColumns, true);					
			// this.resultColumns = this.resultColumns.map(i => i);
		});
		// Update parse result to database
		await this.a3iService.updateA3iParseResult(this.selectedLayer.id, a3iOutputWithId);

		this.updateParseDisable();
		this.updateSaveParseDisable();
	}
	private async getData(pageNum?: number) {
		this.clearTableData();

		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		if (!selectedLayer) {
			return;
		}

		// Attribute filters
		const attrFilters = this.attrFilterService.attrFilters.getValue().filters;
		// Get gfo
		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, attrFilters.filter(f => f && f.filter).map(f => f.filter));
		// Get qaCodes
		const qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
		const paging: PagingParam = {
			pageSize: this.pageSize
		};
		if (pageNum) {
			paging.pageNumber = pageNum;
		} else {
			paging.rowCount = 1;
			paging.pageNumber = 1;
		}
		const randomId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, randomId);
		try {
			const isMapFilterOn = this.activityService.mapFilterBS.getValue().isOn;
			if (!isMapFilterOn) {
				const rsp = await this.qcService.getQcFeatureReport(selectedLayer.id, qaCodes, gfo, paging);
				this.rowsAll = rsp.data;
				this.mainDataService.addDataToStoredRecords(rsp.data, this.a3iService.uniqueIdCol);
				// this.rowsAll.forEach(r => {
				// 		// // Set unique id for internal use
				// 		// r[this.a3iService.uniqueIdCol] = this.commonService.getRandomId();
				// 	// Store the original data WITH id
				// 	r[this.attrIndexService.originalDataKey] = JSON.parse(JSON.stringify(r))
				// });
				this.a3iService.clearEditsSubject.next();
				//
				this.filterRowsByParseCode();
			
				if (paging.rowCount) {
					this.setTablePaging(rsp.totalCount);
				}

			} else {

				// const featsAll = this.mainDataService.wholeData.feats;
				// const currentExt = this.mapService.map.olMap.getView().calculateExtent();
				// const featsInExtent = this.mapService.filterFeaturesInExtent(featsAll, currentExt);
				
				// TODO
			}
		} catch (err) {
			this.setTablePaging(0);
		}
		this.commonService.setLoadingSpinner(false, randomId);
	}
	private async parse() {
		const prefix = this.selectedLayer.category.colPrefix;
		const addresses: string[] = [];
		const filtered = this.sourceRows.filter(r => r[this.checkCol]);
		filtered.forEach((r, idx) => {
			if (!this.checkRowParsable(r)) {
				return;
			}
				// const parts = [];
				// this.lstStandardCols.forEach(c => {
				// 	const part = r[`${prefix}_${c.colName.toLowerCase()}`];
				// 	if (part) {
				// 		parts.push(part.trim());
				// 	}
				// });
				// const inputAddr = parts.join(' ').trim();
			const inputAddr = this.a3iService.combinePartsToAddress(this.lstStandardCols, prefix, r);
			r[this.inputAddrCol] = inputAddr;
			this.resultRows[idx][this.inputAddrCol] = inputAddr;
			addresses.push(inputAddr);
		});
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const rsp = await this.a3iService.parseAddress(addresses, this.userService.customerInfo.givState);

			await this.updateParseResult(rsp.data);

			const successRate = this.calculateSuccessRate(rsp.data);
			this.toastr.success(`Successfully parsed. Success Rate: ${successRate}%`);
		} catch (err) {
			console.log(err);
			this.toastr.error('Failed.');
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private calculateSuccessRate(results: any[]) {
		const successAmount = results.filter(((item: any) => item[this.parseCodeCol] == 's')).length;
		const allAmount = results.length;
		const successRate = Math.ceil(successAmount/allAmount*100);
		return successRate;
	}
	private async saveParseResult() {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const ids = this.sourceRows.filter(i => i[this.checkCol] && this.checkRowCommitable(i)).map(i => i[this.idCol]);
			if (ids.length) {
				await this.a3iService.updateNenaPartsByA3i(this.selectedLayer.id, ids);
				this.toastr.success('Successfully committed');
				await this.getData(this.pageNumber);
			}
		} catch (err) {
			console.log(err);
			this.toastr.error('Failed.');
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private checkRowParsable(row): boolean {
		if (row[this.updateCol] || row[this.resultCol]) {
			return false;
		}
		return true;
	}
	private checkRowCommitable(row): boolean {
		if (!row[this.updateCol] && row[this.resultCol]) {
			return true;
		}
		return false;
	}
	private updateParseDisable() {
		const disabled = !this.sourceRows.filter(r => r[this.checkCol]).find(r => this.checkRowParsable(r));
		if (disabled !== this.a3iService.parseDisableBS.getValue().disabled) {
			this.a3iService.parseDisableBS.next({
				disabled: disabled
			});
		}
	}
	private updateSaveParseDisable() {
		const disabled = !this.sourceRows.filter(r => r[this.checkCol]).find(r => this.checkRowCommitable(r));
		if (disabled !== this.a3iService.saveParseDisableBS.getValue().disabled) {
			this.a3iService.saveParseDisableBS.next({
				disabled: disabled
			});
		}
	}

	private async initColumns(layer: AppLayer) {
		this.selectedLayer = layer;
		const prefix = layer.category.colPrefix;
		this.updateCol = `${prefix}_${this.attrIndexService.a3iUpdateColName}`;
		this.resultCol = `${prefix}_${this.attrIndexService.a3iResultColName}`;
		this.idCol = `${prefix}_${this.attrIndexService.idColName}`;
		//
		let standardSchema = layer.category.standardCols;
		if (!standardSchema) {
			standardSchema = await this.fieldMappingService.getStandardSchema(layer.category.id);
			layer.category.standardCols = standardSchema;
		}
		// Columns
		this.lstStandardCols = this.a3iService.getLstStandardCols(standardSchema); // standardSchema.filter(c => c.colName.toLowerCase().startsWith('lst_'));
		this.stStandardCols = this.a3iService.getStStandardCols(standardSchema);
		const sourceColumns_nena: TableColumn[] = [];
		const sourceColumns_legacy: TableColumn[] = [];
		const resultColumns: TableColumn[] = [];
		const editColumns: TableColumn[] = [];
		// Check col
		this.addCol(this.checkCol, ' ', [sourceColumns_nena, sourceColumns_legacy, resultColumns], null, this.checkCellTempl, true, this.checkboxHeaderTempl);
		// Parse code col
		this.addCol(this.parseCodeCol, ' ', [sourceColumns_nena, sourceColumns_legacy, resultColumns], null, this.parseCodeCellTempl, true)
		// Nguid col
		const nguidStandardCol = standardSchema.find(c => c.colName.toLowerCase() === this.attrIndexService.nguidCol.toLowerCase());
		this.nguidCol = `${prefix}_${nguidStandardCol.colName.toLowerCase()}`;
		this.addCol(this.nguidCol, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], nguidStandardCol, this.commonTemplateService.nguidCellTemplate, true, this.headerTempl, nguidStandardCol.htmlTooltip, 40);

		// Msag col & esn col
		const msag = this.attrIndexService.msagColName;
		const esn = this.attrIndexService.esnColName;
		const masgWidth = 80;
		const esnWidth = 70;
		if (layer.category.code === this.attrIndexService.cateCodeAddress) {
			const msagStandardCol = standardSchema.find(c => c.colName.toLowerCase() === msag);
			this.addCol(`${prefix}_${msag}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardCol, null, true, this.headerTempl, msagStandardCol.htmlTooltip, masgWidth);
			const esnStandardCol = standardSchema.find(c => c.colName.toLowerCase() === esn);
			this.addCol(`${prefix}_${esn}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardCol, null, true, this.headerTempl, esnStandardCol.htmlTooltip, esnWidth);
		} else if (layer.category.code === this.attrIndexService.cateCodeCenterline) {
			const msagLeft = msag + '_l';
			const msagRight = msag + '_r';
			const msagStandardColLeft = standardSchema.find(c => c.colName.toLowerCase() === msagLeft);
			const msagStandardColRight = standardSchema.find(c => c.colName.toLowerCase() === msagRight);
			this.addCol(`${prefix}_${msagLeft}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardColLeft, null, true, this.headerTempl, msagStandardColLeft.htmlTooltip, masgWidth);
			this.addCol(`${prefix}_${msagRight}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], msagStandardColRight, null, true, this.headerTempl, msagStandardColRight.htmlTooltip, masgWidth);
			const esnLeft = esn + '_l';
			const esnRight = esn + '_r';
			const esnStandardColLeft = standardSchema.find(c => c.colName.toLowerCase() === esnLeft);
			this.addCol(`${prefix}_${esnLeft}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardColLeft, null, true, this.headerTempl, esnStandardColLeft.htmlTooltip, esnWidth);
			const esnStandardColRight = standardSchema.find(c => c.colName.toLowerCase() === esnRight);
			this.addCol(`${prefix}_${esnRight}`, null, [sourceColumns_nena, sourceColumns_legacy, resultColumns], esnStandardColRight, null, true, this.headerTempl, esnStandardColRight.htmlTooltip, esnWidth);
		}

		this.lstStandardCols.forEach(c => {
			this.addCol(`${prefix}_${c.colName.toLowerCase()}`, null, [sourceColumns_legacy, editColumns], c, null, null, this.headerTempl, c.htmlTooltip);
		});
		this.stStandardCols.forEach(c => {
			const colResult = this.addCol(c.colName.toLowerCase(), null, [resultColumns], c, null, null, this.headerTempl, c.htmlTooltip)
			//
			const colSource = this.addCol(`${prefix}_${c.colName.toLowerCase()}`, null, [sourceColumns_nena, editColumns], c, null, null, this.headerTempl, c.htmlTooltip);
			colSource.cellClass = this.setCellClass;
			colSource.info.matchingResultCol = colResult.prop;
		})
		this.sourceColumns_nena = sourceColumns_nena;
		this.sourceColumns_legacy = sourceColumns_legacy;
		this.setSourceColumnsByType();
		this.resultColumns = resultColumns;
		this.a3iService.a3iEditColumnsBS.next({
			columns: editColumns
		});
	}
	private addCol(prop, name, addTo: any[], standardSchema?: LayerCategoryStandardSchema, cellTempl?, skipSmartDisplay?, headerTempl?: TemplateRef<any>, tooltip?: string, width?: number) {
		const col = this.tableService.setNewColumn(prop, name, {
			width: width || 30,
			align: 'C'
		});
		if (skipSmartDisplay) {
			col.info.skipSmartDisplay = true;
		}
		if (cellTempl) {
			col.cellTemplate = cellTempl;
		}
		if (headerTempl) {
			col.headerTemplate = headerTempl;
		}
		if (tooltip) {
			col.info.tooltip = tooltip;
		}
		if (standardSchema) {
			col.info.isUppercase = standardSchema.isUppercase;
		}
		addTo.forEach(i => i.push(col));
		return col;
	}
	ngOnInit() {
		this.selectedParseCode = this.parseCodes[0];
		this.inputAddrCol = this.attrIndexService.parseInputAddrCol;
	}
	ngAfterViewInit(): void {
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(async data => {
			if (!data) {
				return;
			}
			const layer = data.layer;
			this.a3iService.uniqueIdCol = layer.category.colPrefix + '_' + this.attrIndexService.globalIdColStandard;
			await this.initColumns(layer);
			await this.getData();
		});
		this.selectedRecordA3iSub = this.a3iService.selectedRecordA3iBS.subscribe(data => {
			if (data.source === 'table') {
				return;
			}
			if (data.record) {
				const id = this.a3iService.getRecordId(data.record);
				const sourceRow = this.sourceRows.find(r => this.a3iService.getRecordId(r) === id);
				const resultRow = this.resultRows.find(r => this.a3iService.getRecordId(r) === id);
				if (sourceRow) {
					this.selectedSourceRows = [sourceRow];
				} else {
					this.selectedSourceRows = [];
				}
				if (resultRow) {
					this.selectedResultRows = [resultRow];
				} else {
					this.resultRows = [];
				}
			} else {
				this.selectedResultRows = [];
				this.selectedSourceRows = [];
			}
		})
		this.parseSub = this.a3iService.parseSubject.subscribe(async data => {
			await this.parse();
		});
		this.saveParseSub = this.a3iService.saveParseSubject.subscribe(async data => {
			await this.saveParseResult();
		});
		this.commitSub = this.a3iService.commitSubject.subscribe(async data => {
			if (data.state === 'done') {
				const current = this.selectedSourceRows[0];
				await this.getData(this.pageNumber);
				if (current) {
					const selectedRecord = this.sourceRows.find(r => this.a3iService.getRecordId(r) === this.a3iService.getRecordId(current));
					this.a3iService.selectedRecordA3iBS.next({
						record: selectedRecord
					});
				}
			}
		});
	}
	ngOnDestroy(): void {
		this.selectedLayerSub.unsubscribe();
		this.selectedRecordA3iSub.unsubscribe();
		this.parseSub.unsubscribe();
		this.saveParseSub.unsubscribe();
		this.commitSub.unsubscribe();
	}
}
